import React from "react";
import Common from "us.common";
import { useTranslation } from "react-i18next";
import { IAccountRecord } from "us.collection.economy/components/RemitHistory/Components/LedgerDashboard/Interfaces";
const { $AmountLabel, $Tooltip } = Common.Components;

const Item: React.FC<IAccountRecord> = (props) => {
  const { accountName, debitAmount, creditAmount, cfBalance, openingBalance } =
    props.record ?? {};
  const { t } = useTranslation([
    "US.COLLECTION.ECONOMY",
    "US.COLLECTION.COMMON",
  ]);

  return (
    <>
      <div className="cardledger-wrap-inner">
        <div className="cardledger">
          <div className="cardledger-item text-truncate text-nowrap font-weight-bold">
            <$Tooltip title={accountName}>{accountName}</$Tooltip>
          </div>
          <div className="d-flex" style={{ height: "100%" }}>
            <div className="flex-fill cardledger-amt text-right text-nowrap">
              {openingBalance > 0 && (
                <span className="d-flex justify-content-between text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.B/F_BALANCE"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={openingBalance} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={openingBalance} />
                    </span>
                  </$Tooltip>
                </span>
              )}
              {openingBalance < 0 && debitAmount > 0 && (
                <span className="d-flex justify-content-between pt-4 text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.REMITS"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={debitAmount} />}>
                      <span className="font-weight-bold">
                        <$AmountLabel value={debitAmount} />
                      </span>
                  </$Tooltip>
                </span> 
              )}
              {openingBalance >= 0 && debitAmount > 0 && (
                <span className="d-flex justify-content-between text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.REMITS"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={debitAmount} />}>
                      <span className="font-weight-bold">
                        <$AmountLabel value={debitAmount} />
                      </span>
                  </$Tooltip>
                </span> 
              )}
              {cfBalance < 0 && debitAmount > 0 &&(
                <span className="d-flex justify-content-between mb-2 text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.C/F_BALANCE"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={-1.0 * cfBalance} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={-1.0 * cfBalance} />
                    </span>
                  </$Tooltip>
                </span>
              )}
              {cfBalance < 0 && debitAmount == 0 &&(
                <span className="d-flex justify-content-between mb-2 pt-5 text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.C/F_BALANCE"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={-1.0 * cfBalance} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={-1.0 * cfBalance} />
                    </span>
                  </$Tooltip>
                </span>
              )}
            </div>
            <div className="flex-fill cardledger-amt flex-column text-right text-nowrap">
              {openingBalance < 0 && (
                <span className="d-flex justify-content-between text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.B/F_BALANCE"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={-1 * openingBalance} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={-1 * openingBalance} />
                    </span>
                  </$Tooltip>
                </span>
              )}
              {openingBalance <= 0 && creditAmount > 0 && (
                <span className="d-flex justify-content-between text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.REMITS"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={creditAmount} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={creditAmount} />
                    </span>
                  </$Tooltip>
                </span>
              )}
              {openingBalance > 0 && creditAmount > 0 && (
                <span className="d-flex justify-content-between pt-4 text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.REMITS"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={creditAmount} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={creditAmount} />
                    </span>
                  </$Tooltip>
                </span>
              )}
              {cfBalance > 0 && creditAmount > 0 && (
                <span className="d-flex justify-content-between mb-2 text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.C/F_BALANCE"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={cfBalance} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={cfBalance} />
                    </span>
                  </$Tooltip>
                </span>
              )}
              {cfBalance > 0 && creditAmount == 0 && (
                <span className="d-flex justify-content-between mb-2 pt-5 text-nowrap">
                  <small className="d-flex justify-content-between pr-2 pt-1">
                    {t(
                      "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.C/F_BALANCE"
                    )}
                  </small>
                  <$Tooltip title={<$AmountLabel value={cfBalance} />}>
                    <span className="font-weight-bold">
                      <$AmountLabel value={cfBalance} />
                    </span>
                  </$Tooltip>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Item;
